import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IoTDeviceRecord {
  id: string;
  tenantId: string;
  partyId: string;
  deviceType: string;
  model: string;
  status: string;
  lastSeenUtc?: string | null;
  metadataJson: string;
}

export interface IoTDeviceCommandRecord {
  id: string;
  tenantId: string;
  deviceId: string;
  commandType: string;
  payloadJson: string;
  status: string;
  issuedByUserId?: string | null;
  sentAtUtc?: string | null;
  ackedAtUtc?: string | null;
  failedAtUtc?: string | null;
  expiresAtUtc: string;
  failureReason?: string | null;
  createdAtUtc: string;
}

export interface IoTCommandAuditRecord {
  id: string;
  deviceId: string;
  commandId: string;
  action: string;
  actorUserId?: string | null;
  detailsJson: string;
  occurredAtUtc: string;
}

@Injectable({ providedIn: 'root' })
export class IoTApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/iot`;

  listDevices(): Observable<IoTDeviceRecord[]> {
    return this.http.get<IoTDeviceRecord[]>(`${this.base}/devices`);
  }

  getDevice(deviceId: string): Observable<IoTDeviceRecord> {
    return this.http.get<IoTDeviceRecord>(`${this.base}/devices/${deviceId}`);
  }

  createDevice(payload: { partyId?: string | null; deviceType: string; model: string; metadataJson: string }): Observable<IoTDeviceRecord> {
    return this.http.post<IoTDeviceRecord>(`${this.base}/devices`, payload);
  }

  activateDevice(deviceId: string): Observable<IoTDeviceRecord> {
    return this.http.post<IoTDeviceRecord>(`${this.base}/devices/${deviceId}/activate`, {});
  }

  listCommands(deviceId: string): Observable<IoTDeviceCommandRecord[]> {
    return this.http.get<IoTDeviceCommandRecord[]>(`${this.base}/devices/${deviceId}/commands`);
  }

  issueCommand(deviceId: string, payload: {
    commandType: string;
    payloadJson: string;
    expiresInSeconds?: number | null;
    confirmed: boolean;
  }): Observable<IoTDeviceCommandRecord> {
    return this.http.post<IoTDeviceCommandRecord>(`${this.base}/devices/${deviceId}/commands`, payload);
  }

  listCommandAudit(deviceId: string, commandId: string): Observable<IoTCommandAuditRecord[]> {
    return this.http.get<IoTCommandAuditRecord[]>(`${this.base}/devices/${deviceId}/commands/${commandId}/audit`);
  }
}
